import { required } from 'vuelidate/lib/validators';

const validations = {
  internalTitle: {
    required,
  },
  title: {
    required,
  },
};

export default validations;
